import { ReactElement } from 'react';
import { useFormikContext } from 'formik';

// Styles
import styles from 'components/forms/FormikFields.module.scss';

// Types
import { IFacetProps, SearchRequest } from 'components/Facets/types';
import { FormikInputField } from 'components/forms';
import { StyledAccordion, StyledAccordionDetails, StyledAccordionSummary } from 'hooks/StyledComponents';

export const TextInput = (props: IFacetProps): ReactElement => {
  const { callback, facet, isExpanded, expandIcon, onToggleExpand } = props;
  const { setFieldValue } = useFormikContext<SearchRequest>();
  const { displayValue, payloadValue } = facet;

  const onKeyPress = (e): void => {
    const value = e.target.value;
    setFieldValue(payloadValue, value);

    // Clicking the enter button should call the callback.
    if (e.which === 13) {
      callback?.();
    }
  };

  return (
    <StyledAccordion key={displayValue} expanded={isExpanded} onChange={onToggleExpand}>
      <StyledAccordionSummary
        aria-controls={`${displayValue}-content`}
        expandIcon={expandIcon}
        id={`${displayValue}-header`}
      >
        {displayValue}
      </StyledAccordionSummary>
      <StyledAccordionDetails>
        <span className="search-box--small">
          <FormikInputField
            className={styles.input}
            formikKey={payloadValue}
            name={payloadValue}
            onKeyPress={onKeyPress}
            placeholder={displayValue}
            title={displayValue}
            type="text"
          />
        </span>
      </StyledAccordionDetails>
    </StyledAccordion>
  );
};
